@if (config) {
  <div class="hero">
    <img
      [src]="config.heroImageUrl"
      alt="{{ config.brandName }} Banner"
      class="hero-image"
      />
    <div class="hero-message">
      <h1>{{ config.welcomeMessage }}</h1>
    </div>
  </div>
}
